import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "product-result__card" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "product-result__img" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 1,
  class: "product-result__finish-coming-soon"
}
const _hoisted_6 = { class: "product-result__body" }
const _hoisted_7 = { class: "product-result__stock-number" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "product-result__display-name"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 1,
  class: "product-result__additional-display-name"
}
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "product-result__link",
      href: $props.url
    }, [
      _createElementVNode("div", _hoisted_3, [
        ($props.primaryImageUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "sr-product-card__image",
              src: $props.primaryImageUrl + `?wid=60&hei=60`,
              alt: $props.name
            }, null, 8 /* PROPS */, _hoisted_4))
          : _createCommentVNode("v-if", true),
        (!$props.primaryImageUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Product Finish Image Coming Soon"))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", { innerHTML: $options.stockOrProducts }, null, 8 /* PROPS */, _hoisted_8)
        ]),
        ($props.displayName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("span", { innerHTML: $props.displayName }, null, 8 /* PROPS */, _hoisted_10)
            ]))
          : _createCommentVNode("v-if", true),
        ($props.additionalDisplayName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("span", { innerHTML: $props.additionalDisplayName }, null, 8 /* PROPS */, _hoisted_12)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ], 8 /* PROPS */, _hoisted_2)
  ]))
}